import { Workbox } from 'workbox-window';

export interface UpdatePromptCallbacks {
  onUpdateAvailable(activate: () => void): void;
}

export function registerSw(cb: UpdatePromptCallbacks): void {
  if (!('serviceWorker' in navigator)) return;
  // vite-plugin-pwa emits /sw.js at the site root by default
  const wb = new Workbox('/sw.js');
  wb.addEventListener('waiting', () => {
    cb.onUpdateAvailable(() => {
      wb.addEventListener('controlling', () => window.location.reload());
      wb.messageSkipWaiting();
    });
  });
  wb.register().catch(() => {
    /* dev mode or unsupported browser */
  });
}
